import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const archiveEmployee = async (uuid: string) => {
  const response = await CustomAxios.post(`employees/${uuid}/archive`);
  return response.data;
};

interface UseArchiveEmployeeProps {
  uuid: string;
  onSuccessCallback: () => void;
}

export function useArchiveEmployee({ uuid, onSuccessCallback }: UseArchiveEmployeeProps) {
  return useMutation({
    mutationFn: () => archiveEmployee(uuid),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.allEmployees, uuid] });
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        alert('Failed to archive the employee. Please try again and contact support if the problem persists.');
      }
    },
  });
}
